import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const absenceImporterSelectors = importerSelectors('absence.importer');

export default absenceImporterSelectors;
